import React, { memo } from 'react'

import { getNftCoverImage } from '../../util/nft.helpers'
import CommonNftCard from './CommonNftCard'

const NftCard = ({ t, nft, onClick }) => {
  const { name, metadata } = nft
  const image = getNftCoverImage(metadata)
  return (
    <CommonNftCard
      actionLabel={t('shop.view-item')}
      image={image}
      name={name}
      onClick={onClick}
      metadata={metadata}
      isNft
    />
  )
}

export default memo(NftCard)
